<div class="relative isolate overflow-hidden pt-14">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
            <div class="text-center">
                <h1 class="text-balance text-5xl font-semibold tracking-tight sm:text-7xl text-normal">{{componentModel.title.value}}</h1>
                <p class="mt-8 text-pretty text-lg font-medium sm:text-xl/8 text-normal" >{{componentModel.description.value}}</p>
                <div class="mt-10 flex items-center justify-center gap-x-6">
                    <white-label-button [text]="componentModel.buttonText.value" [link]="componentModel.buttonLink.value"></white-label-button>
                </div>
            </div>
        </div>
    </div>
</div>